import React from 'react'

import type { Theme } from '@material-ui/core'
import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme: Theme) => ({
  root: {},
  fill: {
    fill: theme.palette.primary.main
  },
  paper: {
    fill: '#fff',
    stroke: theme.palette.primary.main,
    strokeWidth: 5
  }
}))

export default function SocialsThumbnail({ ...props }) {
  const classes = useStyles(props)

  return (
    <svg viewBox="0 0 150 150">
      <rect x={0} y={60} width={20} height={20} className={classes.fill} />
      <rect x={55} y={60} width={20} height={20} className={classes.fill} />
      <rect x={110} y={60} width={20} height={20} className={classes.fill} />
    </svg>
  )
}
